import * as React from 'react';

export interface CardPresenterProps {
    items: any[];
    cover?: (item: any) => any;
    title: (item: any) => any;
    description: (item: any) => any;
    onDeleteClick?: (item: any) => void;
}

export class CardPresenter extends React.Component<CardPresenterProps, any> {

    public itemRender(item: any, key: number) {
        return (
            <div className="col-xs-12 col-sm-6" key={key}>
                <div className="profile-box content-box">
                    <div className="content-box-header clearfix bg-default">
                        {(this.props.cover && this.props.cover(item) || 'No image!')}

                        <div className="user-details">
                            {(this.props.title && this.props.title(item)) || 'No title!'}
                            <span>{(this.props.description && this.props.description(item)) || 'No description!'}</span>
                            <a className="pointer btn btn-abs btn-sm btn-sm-abs text-transform-upr font-bold font-size-11 btn-danger" title="Remove" onClick={() => this.props.onDeleteClick && this.props.onDeleteClick(item)}>Remove</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return this.props.items.length && this.props.items.map((item: any, i: number) => this.itemRender(item, i));
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/presenters/card.presenter.tsx